import { makeStyles } from "@material-ui/core/styles";
import GifBgImg from "../../../assets/gifs/celebration-animation.gif";

const useStyles = makeStyles(theme => ({
  //   modalLg: {
  //     minWidth: 600,
  //     [theme.breakpoints.down("xs")]: {
  //       minWidth: "auto",
  //     },
  //   },
  modalContent: {
    padding: "24px 56px",
    "&:before": {
      content: '""',
      background: `url(${GifBgImg}) no-repeat`,
      backgroundPosition: "center",
      backgroundSize: "contain",
      position: "fixed",
      left: 0,
      top: 0,
      height: "100%",
      width: "100%",
      zIndex: "-1",
    },
  },
  closeModal: {
    position: "fixed",
    top: 20,
    right: 20,
    color: "#fff",
  },
  badgeModal: {

    "& h4": {
      fontSize: 20,
    },
    "& h6": {
      fontSize: 20,
      marginTop: 16,
    },
    "& p": {
      fontSize: 15,
      textAlign: "center",
      width: "90%",
    },
    "& img": {
      width: 250,
      height: "auto",
    },
  },
}));

export default useStyles;
